import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HostModeService } from '@shared/services/hostMode.service';
import { ToastrService } from '@shared/services/toastr.service';
import { OrganizationSiteService, SiteDetail } from '@shared/services/organization-site.service';
import { Country, CountryService } from '@shared/services/country.service';
import { finalize } from 'rxjs';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrackByKeyDirective } from '@shared/directives/track-by-key.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { NgxSearchFilterModule } from 'ngx-search-filter';

@Component({
  selector: 'app-geoblock',
  templateUrl: './geoblock.component.html',
  styleUrls: ['./geoblock.component.scss', '../add-site.component.scss'],
  imports: [NgIf, FormsModule, NgFor, TrackByKeyDirective, TranslatePipe, NgxSearchFilterModule],
})
export class GeoblockComponent implements OnInit, OnChanges {
  @Input({ required: true }) site: SiteDetail;

  disabled = true;
  blockedCountries: Set<string> = new Set();
  countries: Country[] = [];
  provisioningInProgress: boolean = false;
  filterUnblocked: string;
  filterBlocked: string;

  constructor(
    private toastr: ToastrService,
    private hostModeService: HostModeService,
    private siteApi: OrganizationSiteService,
    private countryService: CountryService,
  ) {}

  async ngOnInit() {
    this.disabled = !this.hostModeService.isAdvanced(this.site.mode);
    this.loadCountries();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.site) {
      if (this.site.blacklistedCountries) {
        this.blockedCountries = new Set(this.site.blacklistedCountries);
      }
    }
  }

  async loadCountries() {
    await this.countryService.init();
    this.countries = this.countryService.getCountries();
  }

  blockAllCountries() {
    this.blockedCountries = new Set(this.countries.map((c) => c.code));
  }

  enableAllCountries() {
    this.blockedCountries = new Set();
  }

  blockAvailableCountry(countryCode: string) {
    this.blockedCountries.add(countryCode);
  }

  enableBlockCountry(countryCode: string) {
    this.blockedCountries.delete(countryCode);
  }

  createBlacklistedCountries() {
    if (this.disabled) {
      return this.hostModeService.promptSubscribeToMode('SiteModeNotEnabled.advanced');
    }

    this.provisioningInProgress = true;

    this.siteApi
      .patchSite(this.site.domainName, { blacklistedCountries: [...this.blockedCountries] })
      .pipe(
        finalize(() => {
          this.provisioningInProgress = false;
        }),
      )
      .subscribe({
        next: (res) => {
          this.toastr.success();
          this.site.blacklistedCountries = res.blacklistedCountries;
        },
        error: (err) => this.toastr.error(),
      });
  }
}
